import { FaLinkedin, FaGithub, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
    const year = new Date().getFullYear();

    const socialLinks = [
        {
            icon: FaLinkedin,
            href: 'https://www.linkedin.com/in/ionut-horia-cheovari-578064291/',
            label: 'LinkedIn'
        },
        {
            icon: FaGithub,
            href: 'https://github.com/CheovariIonutHRS',
            label: 'GitHub'
        },
        {
            icon: FaInstagram,
            href: 'https://www.instagram.com/cheovariionut',
            label: 'Instagram'
        },
        {
            icon: FaEnvelope,
            href: 'mailto:cheovariionut@yahoo.com',
            label: 'Email'
        },
    ];

    return (
        <footer className="py-12 border-t border-white/5">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                    {/* Copyright */}
                    <p className="text-text-muted text-sm text-center md:text-left">
                        © {year} Cheovari Ionut. All rights reserved.
                    </p>

                    {/* Social Links */}
                    <div className="flex items-center gap-4">
                        {socialLinks.map((social) => (
                            <a
                                key={social.label}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-text-muted hover:text-accent-blue transition-colors duration-300"
                                aria-label={social.label}
                            >
                                <social.icon className="text-lg" />
                            </a>
                        ))}
                    </div>


                </div>
            </div>
        </footer>
    );
};

export default Footer;
